module.exports = __webpack_public_path__ + "static/media/video2.5683999a.mp4";